import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import profile from '../profile.jpg'; // Import your profile picture
import './About.css'; // Optional: Add custom styles here
import Quality from '../quality.png'; // Import your image
import Preformance from '../preformance.png'; // Import your image
import TrustedExpertise from '../trustedexpertise.png'; // Import your image
import Partnership from '../partnership.png'; // Import your image
import Logo from '../sandsfp.svg'; // Import your image

const About = () => {
    return (
        <header className="App-header">
        <Card className="my-10 mx-auto m-4 card" style={{ maxWidth: '600px' }}>
            <Card.Body className='card'>
                <Row className='className="d-flex justify-content-center align-items-center"'>
                <Card.Title className='font-size-2'><u>About Us</u></Card.Title>
                        
                <img
                            src={Logo}
                            alt="Sands Fire Protection Logo"
                            className="img-logo mx-2"
                        />
                        
                        <Card.Text className='font-size-2'>
                            At Sands Fire Protection, trust, quality, and performance are the cornerstones of everything we do. We are committed to providing exceptional service and ensuring the success of our clients through reliable fire protection solutions.
                        </Card.Text>

                </Row>
            </Card.Body>
        </Card>

        <Card className="my-10 mx-auto m-4 card" style={{ maxWidth: '600px' }}>
            <Card.Body className='card'>
                <Row className='className="d-flex justify-content-center align-items-center"'>
                <Card.Title className='font-size-2'><u>How we Excel</u></Card.Title>
                        <Card.Text className='font-size-2'>
<div className='mb-3'>
<div className='mb-3' style={{display:"flex"}}>Unmatched Quality – Our installations meet the highest industry standards, ensuring systems work flawlessly when it matters most.
<img
                            src={Quality}
                            alt="Unmatched Quality"
                            className="img-fluid rounded-circle mx-2"
                        />
</div>
                      
<div className='mb-3' style={{display:"flex"}}>
    
<img
                            src={Preformance}
                            alt="Proven Preformance"
                            className="img-fluid rounded-circle mx-2"
                        />
    Proven Performance – We streamline the process, delivering on schedule without costly delays or rework.



</div>

<div className='mb-3' style={{display:"flex"}}>Trusted Expertise – With deep knowledge of codes, regulations, and best practices, we help you stay compliant while maximizing efficiency.

<img
                            src={TrustedExpertise}
                            alt="Trusted Expertise"
                            className="img-fluid rounded-circle mx-2"
                        />

</div>

<div className='mb-3' style={{display:"flex"}}>
    
<img
                            src={Partnership}
                            alt="Reliable Partnership"
                            className="img-fluid rounded-circle mx-2"
                        />
    
    Reliable Partnership – We don’t just install; we support. From initial consultation to ongoing maintenance, we’re in it for the long haul.



</div>
</div>
<p>Choosing the right fire alarm company means stress free projects. Let’s build something safer—together.</p>

                        </Card.Text>
                    <Col md={6} className="d-flex justify-content-center align-items-center">
                        
                        {/* <img
                            src={profile}// Replace with your profile picture URL
                            alt="Josh Sands"
                            className="img-fluid rounded-circle"
                        /> */}
                    </Col>
                    <Col md={8}>


                    </Col>
                </Row>
            </Card.Body>
        </Card>


        <Card className="my-10 mx-auto m-4 card" style={{ maxWidth: '600px' }}>
            <Card.Body className='card'>
                <Row className='className="d-flex justify-content-center align-items-center"'>
                <Card.Title className='font-size-2'><u>Request an estimate:</u></Card.Title>
                <Card.Text className='font-size-2'>
                            {/* Josh Sands<br />
                            Owner<br /> */}
                          

                            (512) 677-5857<br />
                            <a href="mailto:estimating@sandsfp.com">estimating@sandsfp.com</a><br />
                             {/* Austin, TX */}
                        </Card.Text>

                </Row>
            </Card.Body>
        </Card>


        </header>
    );
};

export default About;